export default __webpack_public_path__ + "static/media/Zahner_Render_Materials.fc970937.zip";